import {Component, ElementRef, Input, Output, EventEmitter, ViewChild, Inject} from '@angular/core';
import {Config} from '../config';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import {FormControl, FormGroup} from '@angular/forms';

import MapImageLayer = require('esri/layers/MapImageLayer');
import Point = require('esri/geometry/Point');
import SimpleFillSymbol = require('esri/symbols/SimpleFillSymbol');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import SimpleMarkerSymbol = require('esri/symbols/SimpleMarkerSymbol');
import PictureMarkerSymbol = require('esri/symbols/PictureMarkerSymbol');
import Polygon = require('esri/geometry/Polygon');
import Polyline = require('esri/geometry/Polyline');
import Geometry = require('esri/geometry/Geometry');
import GeometryEngine = require('esri/geometry/geometryEngine');
import on = require('dojo/on');
import ScreenPoint = require('esri/geometry/ScreenPoint');
import Color = require('esri/Color');
import Graphic = require('esri/Graphic');
import Legend = require('esri/widgets/Legend');
import Collection = require('esri/core/Collection');
import Sublayer = require('esri/layers/support/Sublayer');
import {ParcelReportService} from '../tools/parcelReport.service';

import * as cloneDeep from "lodash.clonedeep";

declare let componentHandler: any;

@Component({
    selector: 'legend-component',
    template: require('../tools/legend.component.html'),
    styles: [require('../tools/legend.component.css')]
})
export class LegendComponent {
    dynamicLayers:Array<any> = [];
    private dynamicLayersForMS:Array<any> = [];
    colorString:string = "rgb(255, 255, 0)";
    appSettings:Object = null;
    //compPlanLayer:MapImageLayer;
    moduleLayers:Array<any>;
    moduleLayerItem:number = 0;
    layerDefinitionExpr:string;
    arrowIconValue:string = "keyboard_arrow_right";
    searchModuleName:string = "";
    searchModuleIcon:string = "";
    searchModule:any;
    showChip:boolean = false;

    transPlanLogo:string = "./images/transportation.jpg";
    landUsePlanLogo:string = "./images/land_use.png";
    neighbLogo:string = "./images/icon_boundaries.png";
    parcelLogo:string = "./images/Property_Icon3_100x100.png";
    drawPolygonLogo:string = "./images/ic_edit_location_white_24dp_2x.png";
    freeHandPolygonLogo:string = "./images/ic_mode_edit_white_24dp_2x.png";
    private mapPin:string = "./images/map_pin_red-128.png";
    geometryFilterType:string = "";
    geomFilterLogo:string = "";
    obliqueImageLogo: string = "./images/ic_photo_white_24dp_2x.png";
    loadingLegendImage:string = "./images/loading.gif";

    showLegend:boolean = false;
    mapLoading:boolean = false;

    geoDefinitionExpressions:Array<Object> = [];
    filterGeometry:Geometry = null;
    geometryOptions:boolean = false;
    filterGeometryObject:any;

    private queryIteration:number = 0;
    private queryMSIteration:number = 0;

    onlyGeomControl:FormControl = new FormControl();
    showOnlyWithinGeometry:boolean = false;
    showObliqueImage:boolean = false;
    displayObliqueImage:boolean = true;

    bufferSliderValue:string = "0";

    showAddressComponent:boolean = true;

    parcelReportOption:boolean = false;
    parcelReportFeature:Graphic;
    _parcelReportService:ParcelReportService;
    imgElementParcelReport:HTMLElement;
    parcelReportIconPath:string = "./images/parcel-report-icon.png";
    parcelReportIconLoading:string = "./images/loading.gif";
    parcelReportElementTitle:string = "Generate Parcel Report";
    reportGenerationInProgress:boolean = false;
    reportID:number = 0;

    IEbrowser:boolean = false;
    internetExplorer:boolean = false;

    private operationalLayersCount:number = 0;

    @Output() appURLCreated = new EventEmitter<string>();
    
    constructor(private elRef:ElementRef, private _mapService:MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService,  @Inject(ParcelReportService) prs){
        if(this.appSettings == null){
            this.appSettings = Config.config[0];
        }
        this._parcelReportService = prs;
    }

    ngOnInit(){
        this._eventsService.dynamicLayerViewCreated$.subscribe(show => 
            {
                this.operationalLayersCount++;
                if(this.appSettings["Map"]["Layers"]["OperationalLayers"].length == this.operationalLayersCount){
                    this._eventsService.moduleSelect$.subscribe(module => {
                        for (var miLayer of this.appSettings["Map"]["Layers"]["OperationalLayers"]){
                            this._mapService.view.map.findLayerById(miLayer.id).visible = false;
                        }
                        this.startLegendCreate(module);
                    });
                }
            }
        );

        this._eventsService.startSaveSearch$.subscribe(() =>
        {
            try{
                var saveModule = this.createObjectForSavedSearch();
                window.localStorage.setItem("PlanIndy_saved_search", JSON.stringify({
                    "module": saveModule,
                    "geometry": this.filterGeometryObject,
                    "extent": this._mapService.view.extent,
                    "buffer": this.bufferSliderValue,
                    "showOnlyWithinGeometry": this.showOnlyWithinGeometry
                }));
            }catch(error){
                console.log(error);
            }
        });

        this._eventsService.createAppURL$.subscribe(shareMethod => {
            try{
                var saveModule = this.createObjectForSavedSearch();
                var searchUrl:string = /*window.location.href.split('?')[0] + "?" + */JSON.stringify({
                    "module": saveModule,
                    "geometry": this.filterGeometryObject,
                    "extent": this._mapService.view.extent,
                    "buffer": this.bufferSliderValue,
                    "showOnlyWithinGeometry": this.showOnlyWithinGeometry
                })//.replace(new RegExp(' ', 'g'), '%20');
                this.appURLCreated.next(JSON.stringify({"url":searchUrl, "method":shareMethod}));
                console.log(searchUrl);
            }catch(error){
                console.log(error);
            }
        });

        this._eventsService.navItem$.subscribe(suggestion => {
            this.filterGeometryObject = suggestion;
            this.removeGeometryFilter();
            this.queryMSIteration = 0;
            ///Add parcel report option for "ParcelNumber" and "Address" types
            switch(suggestion["addressSuggestion"]["SuggestionType"]){
                case "ParcelNumber":
                    this.parcelReportElementTitle = "Generate Parcel Report";
                    this.parcelReportOption = true;
                    this.reportGenerationInProgress = false;
                    this.reportID = 0;
                    var graphic = new Graphic();
                    graphic.geometry = suggestion["addressLocation"];
                    graphic.attributes = {};
                    graphic.attributes["Parcel Number"] = suggestion["addressSuggestion"]["FullName"];
                    graphic.attributes["Parcel Address"] = suggestion["addressSuggestion"]["ShowAddress"];
                    this.parcelReportFeature = graphic;
                    break;
                case "Address":
                    this.parcelReportElementTitle = "Generate Parcel Report";
                    this.getParcelFeatureFromCoordinates(suggestion);
                    break;
                default: 
                    this.parcelReportOption = false;
                    break;
            }
            if(suggestion["addressSuggestion"]["SuggestionType"] == "Neighborhood" || suggestion["addressSuggestion"]["SuggestionType"] == "ParcelNumber" || suggestion["addressSuggestion"]["SuggestionType"] == "DrawPolygon" || suggestion["addressSuggestion"]["SuggestionType"] == "FreeHandPolygon"){
                var filterPolygon:Polygon = new Polygon();
                filterPolygon.rings = suggestion["addressLocation"]["rings"];
                filterPolygon.spatialReference = this._mapService.view.spatialReference;
                this.filterGeometry = filterPolygon;
                if(suggestion["addressSuggestion"]["SuggestionType"] == "ParcelNumber"){
                    this.geometryFilterType = "Parcel " + suggestion["addressSuggestion"]["FullName"];
                }else{
                    this.geometryFilterType = suggestion["addressSuggestion"]["FullName"];
                }
                this.queryForFilterGeometry(this.filterGeometry);
                this._mapService.view.extent = this.filterGeometry.extent;
                this.showGeometryOnMap(this.filterGeometry, "filterPolygon");
            }else{
                if(suggestion["buffer"]){
                    this.bufferSliderValue = suggestion["buffer"];
                }
                var point:Point = new Point({
                    x: suggestion["addressLocation"]["X"],
                    y: suggestion["addressLocation"]["Y"],
                    spatialReference: this._mapService.view.spatialReference
                });
                this.filterGeometry = point;
                this.geometryFilterType = suggestion["addressSuggestion"]["FullName"];
                if (this.bufferSliderValue == "0"){
                    this.queryForFilterGeometry(this.filterGeometry);
                    this.showGeometryOnMap(this.filterGeometry, "filterPolygon");
                }else{
                    this.showGeometryOnMap(this.filterGeometry, "filterPolygon");
                    this._esriTasksService.bufferFeatures(this.appSettings["GeometryService"]["url"], [this.filterGeometry], [this.bufferSliderValue], "feet", this._mapService.view.spatialReference).then(geometries => {
                            if(geometries.length > 0){
                                this.geoDefinitionExpressions = [];
                                this.queryForFilterGeometry(geometries[0]);
                                this.showGeometryOnMap(geometries[0], "pointBuffer");
                            }
                    })
                }
            }
            this.setGeomFilterLogo(suggestion);
        });

        this._eventsService.setSavedGeometry$.subscribe(savedGeometry => {
            this.filterGeometryObject = savedGeometry.geometry;
            this.removeGeometryFilter();
            this.queryMSIteration = 0;
            if(this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "Neighborhood" || this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "ParcelNumber" || this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "DrawPolygon" || this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "FreeHandPolygon"){
                var filterPolygon:Polygon = new Polygon();
                filterPolygon.rings = this.filterGeometryObject["addressLocation"]["rings"];
                filterPolygon.spatialReference = this.filterGeometryObject["addressLocation"]["spatialReference"];
                this.filterGeometry = filterPolygon;
            }else{
                if(savedGeometry["buffer"]){
                    this.bufferSliderValue = savedGeometry["buffer"];
                }
                var point:Point = new Point({
                    x: this.filterGeometryObject["addressLocation"]["X"],
                    y: this.filterGeometryObject["addressLocation"]["Y"],
                    spatialReference: this._mapService.view.spatialReference
                });
                this.filterGeometry = point;
            }
            this.showOnlyWithinGeometry = savedGeometry["showOnlyWithinGeometry"];
            this.geometryFilterType = this.filterGeometryObject["addressSuggestion"]["FullName"];
            this.setGeomFilterLogo(this.filterGeometryObject);
            this.showGeometryOnMap(this.filterGeometry, "filterPolygon");
        });

        this._eventsService.showObliqueImage$.subscribe(show => {
            this.showObliqueImage = show;
        });

        this._eventsService.addressSearchActivate$.subscribe(show =>
            this.showAddressComponent = (show as boolean)
        );

        this._eventsService.mapUpdateShow$.subscribe(show => {
            this.mapLoading = show;
        });

        //Determine if IE or Edge browser
        try {
            if(navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1 || navigator.userAgent.indexOf("Edge/") != -1)
            {
                this.IEbrowser = true;
            }
            if(navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1){
                this.internetExplorer = true;
            }
        } catch (error) {
            console.log("Could not find browser type");
        }
    }

    ngAfterViewInit(){
        this.onlyGeomControl.valueChanges
             .subscribe(toggleValue => {
                 this.showOnlyWithinGeometry = toggleValue;
                 this.applyExceptionsToDefinitionExpressions()
                 if(toggleValue == true){
                    this.applyGeoDefinitionExpressions();
                 }
             });
    }
    
    ngDoCheck(){
        //this._mapService.currentCompPlanLayer = this.compPlanLayer;
    }

    createObjectForSavedSearch():any{
        var saveModule:any = cloneDeep(this.searchModule);
        var layerToDynamicLayers:Object = {};
        for(var layer of saveModule.Layers){
            var sublayersArray:Array<any> = layer.SubLayers;
            for(var subLayer of sublayersArray){
                for(var i:number = 0; i < this.dynamicLayers.length; i++){
                    if(this.dynamicLayers[i]["msId"] == layer["id"] && subLayer["id"] == this.dynamicLayers[i]["id"]){                  
                        subLayer.opacity = (this._mapService.view.map.findLayerById(this.dynamicLayers[i]["msId"]) as MapImageLayer).findSublayerById(this.dynamicLayers[i].id).opacity;
                        subLayer.visible = (this._mapService.view.map.findLayerById(this.dynamicLayers[i]["msId"]) as MapImageLayer).findSublayerById(this.dynamicLayers[i].id).visible;
                    }
                }
            }
            layer.SubLayers = sublayersArray;
        }
        saveModule["dynamicLayers"] = this.dynamicLayers;
        return saveModule;
    }

    private zoomToGeometry(){
        switch (this.filterGeometry.type){
            case "polygon":
                this._mapService.view.extent = this.filterGeometry.extent;
                break;
            case "point":
                this._mapService.view.center = this.filterGeometry as Point;
                this._mapService.view.zoom = 12;
                break;
        }
    }

    private setGeomFilterLogo(suggestion:any){
        switch(suggestion["addressSuggestion"]["SuggestionType"]){
            case "Neighborhood":
                this.geomFilterLogo = this.neighbLogo;
                break;
            case "ParcelNumber":
                this.geomFilterLogo = this.parcelLogo;
                break;
            case "Address":
                this.geomFilterLogo = this.mapPin;
                break;
            case "Intersection":
                this.geomFilterLogo = this.mapPin;
                break;
            case "DrawPolygon":
                this.geomFilterLogo = this.drawPolygonLogo;
                break;
            case "FreeHandPolygon":
                this.geomFilterLogo = this.freeHandPolygonLogo;
                break;
            default:
                this.geomFilterLogo = this.mapPin;
                break;
        }
    }

    private queryForFilterGeometry(geometryToFilter:Geometry){
        if(this.dynamicLayers.length > 0){
            this.queryIteration = 0;
            this.queryForFilterGeometryProcess(geometryToFilter);
        }
    }

    // private queryForFilterGeometryProcess(dynamicLayersForMS:Array<any>, geometryToFilter:Geometry){

        
    //     this.getGeometryFilterDefExpressions(dynamicLayersForMS[this.queryIteration], geometryToFilter)

    //     // if(this.geoDefinitionExpressions.length == this.dynamicLayers.length){
    //     //     this._eventsService.mapUpdateShow(false);
    //     //     this.applyExceptionsToDefinitionExpressions();
    //     //     this.applyGeoDefinitionExpressions();
    //     // }else{
    //     //     this.queryMSIteration++;
    //     //     if(this.searchModule.Layers.length > this.queryMSIteration){
    //     //         this.queryForFilterGeometryProcess(0, geometryToFilter);
    //     //     }
    //     // }
    // }

    private queryForFilterGeometryProcess(geometryToFilter:Geometry){
        try{
            var dynamicLayer:any = this.dynamicLayers[this.queryIteration];
            var queryLayerUrl:string = (this._mapService.view.map.findLayerById(dynamicLayer.msId) as MapImageLayer).url + "/" + dynamicLayer["id"];
            this._eventsService.mapUpdateShow(true);
            this._esriTasksService.queryFeaturesForIDs(queryLayerUrl, geometryToFilter, "1=1").then(result => {
                //var id:string = result["url"].toString();
                var defExpression:string = "1 <> 1";
                if(result.results){
                    var resCount:number = (result.results as Array<any>).length;
                    defExpression = "";
                    if(resCount > 999){    
                        var thousandsCount:number = Math.floor(resCount/999);
                        var countRemainder:number = resCount%999;
                        for (var i:number = 0; i < thousandsCount; i++){
                            if(i == 0){
                                defExpression = defExpression + dynamicLayer["objectIDField"] + " in (" + (result.results as Array<any>).splice(0, 999) + ")";
                            }else{
                                defExpression = defExpression + " OR " + dynamicLayer["objectIDField"] + " in (" + (result.results as Array<any>).splice(0, 999) + ")";
                            }
                        }
                        defExpression = defExpression + " OR " + dynamicLayer["objectIDField"] + " in (" + (result.results as Array<any>).splice(0) + ")";
                        //console.log(defExpression);
                    }else{
                        defExpression = dynamicLayer["objectIDField"] + " in (" + result.results.toString() + ")";
                    }
                }

                this.geoDefinitionExpressions.push(
                {   
                    "msId": dynamicLayer["msId"],
                    "id":dynamicLayer["id"],
                    "definitionExpression": defExpression
                });

                if(this.geoDefinitionExpressions.length == this.dynamicLayers.length){
                    this._eventsService.mapUpdateShow(false);
                    this.applyExceptionsToDefinitionExpressions();
                    if(this.showOnlyWithinGeometry == true){
                        this.applyGeoDefinitionExpressions();
                    }
                    return;
                }else{
                    this._eventsService.mapUpdateShow(true);
                }

                this.queryIteration++;
                if(this.queryIteration < this.dynamicLayers.length){
                    this.queryForFilterGeometryProcess(geometryToFilter);
                }
                // else{
                //     this.queryMSIteration++;
                //     this.queryForFilterGeometry(geometryToFilter)
                // }
            });
        }catch(err){
            console.log(err);
            this._eventsService.mapUpdateShow(false);
        }
    }

    startLegendCreate(module:any){
        this.searchModule = module;
        this.searchModuleName = module["Name"];
        this.searchModuleIcon = module["Icon"];
        this.showChip = true;
        this.dynamicLayers = [];
        this.moduleLayerItem = 0;
        this.moduleLayers = module.Layers;

        this._mapService.currentDynamicLayers = [];
        for(let layer of this.moduleLayers){
            this._mapService.currentDynamicLayers.push(this._mapService.view.map.findLayerById(layer["id"]));
        }

        if(module.dynamicLayers && module.dynamicLayers != null){
            this.dynamicLayers = module.dynamicLayers;
            for(var moduleLayer of this.moduleLayers){
                var miLayer:MapImageLayer = this._mapService.view.map.findLayerById(moduleLayer.id) as MapImageLayer;
                miLayer.visible = true;
                miLayer.sublayers = moduleLayer.SubLayers as Collection;
                this.applyExceptionsToDefinitionExpressions();
            }
            this.getLegendSwatches();
        }else{
            this.preProcessLegendCreate(this.moduleLayers[this.moduleLayerItem]);
        }
    }

    preProcessLegendCreate(moduleLayer:any){
        var miLayer:MapImageLayer = this._mapService.view.map.findLayerById(moduleLayer.id) as MapImageLayer;
        miLayer.visible = true;
        miLayer.sublayers = moduleLayer.SubLayers as Collection;
        this._esriTasksService.getServiceValues(moduleLayer.URL + "/layers?f=pjson").then(item => this.processLegendCreate(item)).catch(error => console.log(error));
    }

    processLegendCreate(item:any){
        try{
            for(var layer of item.layers){

                var miLayer:MapImageLayer = this._mapService.view.map.findLayerById(this.moduleLayers[this.moduleLayerItem]["id"]) as MapImageLayer;
                if(!miLayer.sublayers.find(slyr => {return slyr.id == layer.id})){
                    continue;
                }
                var layerDefExpr:string = miLayer.findSublayerById(layer.id)["definitionExpression"];

                var dynamicLayer:Object = {};

                dynamicLayer["msId"] = this.moduleLayers[this.moduleLayerItem]["id"];
                dynamicLayer["id"] = layer.id;

                var drawingInfo:Object = layer.drawingInfo;
                var fields:Array<any> = layer.fields as Array<any>;
                var objectIDField:any = fields.find(x => x["type"] == "esriFieldTypeOID");
                dynamicLayer["objectIDField"] = objectIDField["name"];
                dynamicLayer["title"] = layer.name;
                dynamicLayer["minScale"] = layer.minScale;
                dynamicLayer["maxScale"] = layer.maxScale;
                //dynamicLayer["drawingInfo"] = layer.drawingInfo;
                switch(layer.geometryType){
                    case "esriGeometryPolygon":
                        dynamicLayer["type"] = "polygon";
                        break;
                }

                var layerDrawingInfos:Array<any> = [];
                switch(drawingInfo["renderer"]["type"]){
                    case "uniqueValue":
                        var rendererFields:Array<string> = [];
                        if(drawingInfo["renderer"]["field1"] != null){
                            rendererFields.push(drawingInfo["renderer"]["field1"]);
                        }
                        if(drawingInfo["renderer"]["field2"] != null){
                            rendererFields.push(drawingInfo["renderer"]["field2"]);
                        }
                        if(drawingInfo["renderer"]["field3"] != null){
                            rendererFields.push(drawingInfo["renderer"]["field3"]);
                        }
                        
                        var uniqueValueInfos:Array<Object> = drawingInfo["renderer"]["uniqueValueInfos"];
                        //var uniqueValueInfoValues:Array<string> = [];
                        var uniqueValueInfoLabels:Array<string> = [];
                        uniqueValueInfos.forEach(element => {
                            // if(uniqueValueInfoValues.indexOf(element["value"]) == -1){
                            //     uniqueValueInfoValues.push(element["value"]);
                            // }
                            if(uniqueValueInfoLabels.indexOf(element["label"]) == -1){
                                uniqueValueInfoLabels.push(element["label"]);
                            }
                        });

                        var uniqueValueInfosMultipleValues:Array<Object> = [];
                        uniqueValueInfoLabels.forEach(label => {
                            var labelValues:Array<string> = [];
                            uniqueValueInfos.forEach(uvi => {
                                if(uvi["label"] == label){
                                    let uviValues:Array<string>
                                    if(rendererFields.length > 1){
                                        uviValues = uvi["value"].split(drawingInfo["renderer"]["fieldDelimiter"]);
                                    }else{
                                        uviValues = [uvi["value"]];
                                    }
                                    uviValues.forEach((uviValue, ind) => {
                                        if(fields.find(f => f["name"] == rendererFields[ind])["type"] == "esriFieldTypeString"){
                                            uviValues[ind] = "'" + uviValue + "'";
                                        }else if(fields.find(f => f["name"] == rendererFields[ind])["type"] == "esriFieldTypeInteger"){
                                            uviValues[ind] = uviValue;
                                        }else{
                                            uviValues[ind] = "'" + uviValue + "'";
                                        }
                                    })                                    
                                    labelValues.push(uviValues.toString());
                                }
                            });
                            uniqueValueInfosMultipleValues.push(
                                {
                                    "label":label,
                                    "value":labelValues
                                }
                            );
                        });
                        uniqueValueInfos = uniqueValueInfosMultipleValues;

                        dynamicLayer["rendererFields"] = rendererFields;
                        dynamicLayer["exceptions"] = [];
                        dynamicLayer["fieldDelimiter"] = drawingInfo["renderer"]["fieldDelimiter"];
                        
                        for(var uvi of uniqueValueInfos){
                            var visibleDef:boolean;
                            if(layerDefExpr == null){
                                visibleDef = true;
                            }else if((layerDefExpr as string).indexOf(uvi["value"]) > -1){
                                dynamicLayer["exceptions"].push(uvi["value"]);
                                visibleDef = false;
                            }else{
                                visibleDef = true;
                            }
                            layerDrawingInfos.push({
                                "label": uvi["label"], 
                                "value": uvi["value"],
                                "visible": visibleDef
                            });
                        }
                        break;
                    case "simple":
                        var visibleDef:boolean;
                        if(layerDefExpr == null){
                            visibleDef = true;
                        }else if((layerDefExpr as string).indexOf(uvi["value"]) > -1){
                            dynamicLayer["exceptions"].push(uvi["value"]);
                            visibleDef = false;
                        }else{
                            visibleDef = true;
                        }
                        layerDrawingInfos.push({
                            "label": "", 
                            "value": "",
                            "visible": visibleDef
                        });
                        break;
                    // case "classBreaks":
                    //     var rendererFields:Array<string> = [];
                    //     rendererFields.push(drawingInfo["renderer"]["field"]);
                    //     var classBreakInfos:Array<Object> = drawingInfo["renderer"]["classBreakInfos"];
                    //     var classBreakInfoValues:Array<string> = [];
                    //     var classBreakInfoLabels:Array<string> = [];
                    //     classBreakInfos.forEach(element => {
                    //         if(classBreakInfoValues.indexOf(element["classMaxValue"]) == -1){
                    //             classBreakInfoValues.push(element["classMaxValue"]);
                    //         }
                    //         if(classBreakInfoLabels.indexOf(element["label"]) == -1){
                    //             classBreakInfoLabels.push(element["label"]);
                    //         }
                    //     });
                    //     break;
                }

                dynamicLayer["drawingInfo"] = layerDrawingInfos;

                dynamicLayer["expanded"] = true;

                this.dynamicLayers.push(dynamicLayer);
            }
            this.moduleLayerItem++;
            if(this.moduleLayerItem < this.moduleLayers.length){
                this.preProcessLegendCreate(this.moduleLayers[this.moduleLayerItem]);
            }else{
                this.moduleLayerItem = 0;
                this.getLegendSwatches();
            }
        }catch(err){
            console.log(err);
        }
    }


    getLegendSwatches(){
        this._esriTasksService.getServiceValues(this.moduleLayers[this.moduleLayerItem].URL + "/legend?f=pjson").then(item => {
            var legendSwatches:Array<any> = [];
            for(var layer of item.layers){
                var currentLayer:Object;
                for(var i:number = 0; i < this.dynamicLayers.length; i++){
                    if(this.dynamicLayers[i]["title"] == layer.layerName){
                        currentLayer = this.dynamicLayers[i];
                        for(var j:number = 0; j < layer.legend.length; j++){
                            this.dynamicLayers[i]["drawingInfo"][j]["imageUrl"] = this.moduleLayers[this.moduleLayerItem].URL + "/" + layer.layerId + "/images/" + layer.legend[j].url;
                        }
                        break;
                    }
                }
            }
            this.moduleLayerItem++;
            if(this.moduleLayerItem < this.moduleLayers.length){
                this.getLegendSwatches();
            }else{
                if(this.filterGeometry != null){
                    this.geoDefinitionExpressions = [];
                    this.queryMSIteration = 0;
                    if(this.filterGeometry.type == "point" && this.bufferSliderValue != "0"){
                        this._esriTasksService.bufferFeatures(this.appSettings["GeometryService"]["url"], [this.filterGeometry], [this.bufferSliderValue], "feet", this._mapService.view.spatialReference).then(geometries => {
                                if(geometries.length > 0){
                                    this.geoDefinitionExpressions = [];
                                    this.queryForFilterGeometry(geometries[0]);
                                    this.showGeometryOnMap(geometries[0], "pointBuffer");
                                }
                        })
                    }else{
                        this.queryForFilterGeometry(this.filterGeometry);
                    }
                }
            }
        }, error => {console.log(error)});
    }

    legendDefinitionChange(valueFilter:Array<string>, checked:boolean, dynamicLayer:Object){
        if(checked == false){
            for(let dl of this.dynamicLayers){
                if(dl["id"] == dynamicLayer["id"] && dl["msId"] == dynamicLayer["msId"]){
                    valueFilter.forEach(value => {
                        (dl["exceptions"] as Array<string>).push(value);
                    });
                }
            }
        }else{
            for(let dl of this.dynamicLayers){
                if(dl["id"] == dynamicLayer["id"] && dl["msId"] == dynamicLayer["msId"]){
                    valueFilter.forEach(value => {
                        var indexToDelete:number = (dl["exceptions"] as Array<string>).indexOf(value);
                        (dl["exceptions"] as Array<string>).splice(indexToDelete, 1);
                    });
                }
            }
        }
        this.applyExceptionsToDefinitionExpressions();
        if(this.geoDefinitionExpressions.length == this.dynamicLayers.length){
            this.applyGeoDefinitionExpressions();
        }
    }

    private applyExceptionsToDefinitionExpressions(){
        for(var dynamicLayer of this.dynamicLayers){
            var subLayer:Sublayer = (this._mapService.view.map.findLayerById(dynamicLayer.msId) as MapImageLayer).findSublayerById(dynamicLayer["id"]);
            if(!dynamicLayer["exceptions"]){
                subLayer.definitionExpression = null;
                continue;
            }
            if((dynamicLayer["exceptions"] as Array<string>).length > 0){
                var definitionExpression:string = this.generateDefinitionExpression(dynamicLayer);
                subLayer.definitionExpression = definitionExpression;
            }else{
                subLayer.definitionExpression = null;
            }
        }
    }

    private generateDefinitionExpression(dynamicLayer:any):string{
        var rendererFields:Array<string> = dynamicLayer["rendererFields"];
        var exceptionsArray:Array<string> = (dynamicLayer["exceptions"] as Array<string>);
        var exceptionsComprArray:Array<any> = [];
        exceptionsArray.forEach((exc) => {
            let excArray:Array<string>;
            if(dynamicLayer["rendererFields"].length > 1){
                excArray = exc.split(dynamicLayer["fieldDelimiter"]);
            }else{
                excArray = [exc];
            }
            var excArrCorrected:Array<any> = [];
            excArray.forEach((indExc, ind) => {
                indExc = indExc.trim();
                excArrCorrected.push(indExc);
            });
            exceptionsComprArray.push(excArrCorrected);
        });
        var definitionExpression:string = "";
        exceptionsComprArray.forEach((excArr, arrInd) => {
            if(arrInd == 0){
                definitionExpression = "NOT (";
            }else{
                definitionExpression = definitionExpression + " AND NOT ("
            }
            excArr.forEach((exc, ind) => {
                if(ind == 0){
                    definitionExpression = definitionExpression + rendererFields[ind] + " = " + exc;
                }else{
                    definitionExpression = definitionExpression + " AND " + rendererFields[ind] + " = " + exc
                }
            });
            definitionExpression = definitionExpression + ")";
        });
        return definitionExpression;
    }

    private applyGeoDefinitionExpressions(){
        if(this.showOnlyWithinGeometry == true){
            for(var defObject of this.geoDefinitionExpressions){
                var subLayer:Sublayer = (this._mapService.view.map.findLayerById(defObject["msId"]) as MapImageLayer).findSublayerById(parseInt(defObject["id"]));
                subLayer.definitionExpression = (subLayer.definitionExpression == "" || subLayer.definitionExpression == null) ? defObject["definitionExpression"] : subLayer.definitionExpression + " AND (" + defObject["definitionExpression"] + ")";
            }
        }
    }

    expandSubLayers(dynamicLayer){
        for(var i:number = 0; i < this.dynamicLayers.length; i++){
            if(this.dynamicLayers[i]["msId"] == dynamicLayer.msId && this.dynamicLayers[i]["id"] == dynamicLayer.id){
                this.dynamicLayers[i]["expanded"] = !dynamicLayer.expanded;
                return;
            }
        }
    }

    openLegend(){
        this.showLegend = true;
    }

    removeGeometryFilter(){
        for (var dynamicLayer of this.dynamicLayers){
            if(!dynamicLayer["exceptions"]){
                (this._mapService.view.map.findLayerById(dynamicLayer["msId"]) as MapImageLayer).findSublayerById(dynamicLayer["id"]).definitionExpression = null;
                continue;
            }
            if((dynamicLayer["exceptions"] as Array<string>).length > 0){
                var definitionExpression:string = this.generateDefinitionExpression(dynamicLayer);
                (this._mapService.view.map.findLayerById(dynamicLayer["msId"]) as MapImageLayer).findSublayerById(dynamicLayer["id"]).definitionExpression = definitionExpression;
            }else{
                (this._mapService.view.map.findLayerById(dynamicLayer["msId"]) as MapImageLayer).findSublayerById(dynamicLayer["id"]).definitionExpression = null;
            }
        }
        this.geoDefinitionExpressions = [];
        this.filterGeometry = null;
        this.clearGeomFilterGraphics(["filterPolygon", "pointBuffer"]);
        //this.showOnlyWithinGeometry = true;
        this.geometryOptions = false;
    }

    showGeometryOptions(){
        this.geometryOptions = !this.geometryOptions;
    }

    clearGeomFilterGraphics(graphicTypes:Array<string>){
        var mapGraphics = this._mapService.applyGeometryQueryGraphic.graphics["items"];
        for (var j = (mapGraphics.length - 1); j >= 0; j--) {
            if (mapGraphics[j].attributes.hasOwnProperty("graphicType") && graphicTypes.indexOf(mapGraphics[j].attributes.graphicType) != -1) {
                this._mapService.applyGeometryQueryGraphic.graphics.remove(mapGraphics[j]);
            }
        }
    }

    private showGeometryOnMap(geometry:Geometry, graphicType:string){
        var graphic = new Graphic();
        graphic.geometry = geometry;
        switch(geometry.type){
            case "polygon":
                var fillSymbol = new SimpleFillSymbol();
                fillSymbol.color = new Color([255, 255, 0, 0.0]);
                var lineSymbol = new SimpleLineSymbol();
                lineSymbol.color = new Color([0, 0, 0]);
                lineSymbol.width = 2;
                fillSymbol.outline = lineSymbol;
                graphic.symbol = fillSymbol;
                graphic.attributes = {};
                graphic.attributes["graphicType"] = graphicType;
                break;
            case "point":
                var pointSymbol:PictureMarkerSymbol = new PictureMarkerSymbol();
                pointSymbol.height = 24;
                pointSymbol.width = 24;
                pointSymbol.url = this.mapPin;
                pointSymbol.yoffset = 12;

                graphic = new Graphic({
                    geometry: geometry as Point,
                    symbol: pointSymbol
                });
                graphic.attributes = {};
                graphic.attributes["graphicType"] = graphicType;

                this._mapService.view.center = geometry as Point;
                this._mapService.view.zoom = 12;

                break;
        }
        this._mapService.applyGeometryQueryGraphic.graphics.addMany([graphic]);
    }

    bufferSliderMouseUp(event:any){
        this.clearGeomFilterGraphics(["pointBuffer"]);
        var bufferValue:string = event.currentTarget.value;
        this.queryMSIteration = 0;
        if(bufferValue == "0"){
            this.geoDefinitionExpressions = [];
            this.queryForFilterGeometry(this.filterGeometry);
            return;
        }
        this._eventsService.mapUpdateShow(true);
        this._esriTasksService.bufferFeatures(this.appSettings["GeometryService"]["url"], [this.filterGeometry], [bufferValue], "feet", this._mapService.view.spatialReference).then(geometries => {
            this._eventsService.mapUpdateShow(false);
            if(geometries.length > 0){
                this.geoDefinitionExpressions = [];
                this._mapService.view.extent = geometries[0].extent;
                this.queryForFilterGeometry(geometries[0]);
                this.showGeometryOnMap(geometries[0], "pointBuffer");
            }
        }, error => {
            this._eventsService.mapUpdateShow(false);
            console.log(error);
        })
    }

    removePictometry(){
        this._eventsService.disableObliqueImage();
    }


    private generateParcelReport(){
        this.reportID = Math.floor(Math.random() * 1000000000);
        var currentReportID = this.reportID;
        this.reportGenerationInProgress = true;
        this._parcelReportService = new ParcelReportService(this._esriTasksService, this._mapService, this._eventsService);
        this.parcelReportElementTitle = "Generating report. Please wait...";
        this._parcelReportService.activeProject.subscribe(thing => 
            {
                if(this.reportID == currentReportID){
                    this.reportGenerationInProgress = false;
                }
            }
        );
        this._parcelReportService.startParcelReport(this.parcelReportFeature);
    }

    private getParcelFeatureFromCoordinates(suggestion){
        var layersArray:Array<any> = [{"Name":"CCGIS.PARCELS","QueryFilter":"","Fields":["PARCEL_C", "STNUMBER", "PRE_DIR", "FULL_STNAME", "CITY", "STATE", "ZIPCODE"],"ReturnGeometry":true}];
        this._esriTasksService.getAPIPResultsByLocation(this.appSettings["APIPSOEService"]["url"], {"X":suggestion.addressLocation.X, "Y":suggestion.addressLocation.Y}, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], layersArray).then(apipResultsData => {
                var apipResult:Array<any> = apipResultsData.data;
                var parcelNumber:any = apipResult["ResultLayers"][0]["Records"][0]["Values"][0];
                var parcelAddress:any = apipResult["ResultLayers"][0]["Records"][0]["Values"][1] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][2] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][3] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][4] + ", " + apipResult["ResultLayers"][0]["Records"][0]["Values"][5] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][6];
                var parcelGraphic:Graphic = new Graphic();
                parcelGraphic.attributes = {"Parcel Number": parcelNumber, "Parcel Address": parcelAddress};
                parcelGraphic.geometry = this._esriTasksService.gmlToGeometry(this._mapService.view.spatialReference, apipResult["ResultLayers"][0]["Records"][0]["Geometry"]);
                this.parcelReportFeature = parcelGraphic;
                this.parcelReportOption = true;
                this.reportGenerationInProgress = false;
                this.reportID = 0;
            }, error => {
                console.log(error);
                this.parcelReportOption = false;
        })
    }

    private calculateLegendMaxHeight():string{
        var offset:number = 160;
        if(this.showAddressComponent)
        {
            offset = offset + 40;
        }
        if(this.showObliqueImage){
            offset = offset + 34;
        }
        if(this.showObliqueImage && this.displayObliqueImage){
            offset = offset + 300;
        }
        if(this.filterGeometry){
            offset = offset + 34;
        }
        if(this.filterGeometry && this.geometryOptions){
            offset = offset + 110;
        }
        return 'calc(100% - ' + offset.toString() + 'px)';
    }

    private calculateLegendHeight():string{
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        if(iOS){
            var offset:number = 160;
            if(this.showAddressComponent)
            {
                offset = offset + 40;
            }
            if(this.showObliqueImage){
                offset = offset + 34;
            }
            if(this.showObliqueImage && this.displayObliqueImage){
                offset = offset + 300;
            }
            if(this.filterGeometry){
                offset = offset + 34;
            }
            if(this.filterGeometry && this.geometryOptions){
                offset = offset + 110;
            }
            return 'calc(100% - ' + offset.toString() + 'px)';
        }else{
            return "auto";
        }
    }

    private legendDivClicked():void{
        componentHandler.upgradeAllRegistered();
        var legendDiv = document.querySelector('.legend-interactive-content');
    }

    private calculateActualElHeight():string{
        var totHeight:number = 0;
        var legendDivs:NodeListOf<any> = document.querySelectorAll('.dynamicLayerDiv');
        legendDivs.forEach(legendDiv =>{
            totHeight = totHeight + legendDiv.clientHeight;
        })
        return totHeight + 10 + "px";
    }
}


// WEBPACK FOOTER //
// ./app/tools/legend.component.ts